import { render, staticRenderFns } from "./ScheduleType.vue?vue&type=template&id=68c6d248"
import script from "./ScheduleType.vue?vue&type=script&lang=js"
export * from "./ScheduleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports